import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Info, ChevronLeft } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";

const initialValuesFromDb = {
  producedBatchNumber: {
    value: "C24050",
    confidence: "95.22875213623047",
  },
  consumedBatchNumber: {
    value: "CPVMT",
    confidence: "94.9330062866211",
  },
  producedBatchCodeBms: {
    value: "1223158",
    confidence: "95.0743408203125",
  },
  producedBatchCodePci: {
    value: "723650",
    confidence: "95.12584686279297",
  },
  expiryDate: {
    value: "07.2025",
    confidence: "94.63017272949219",
  },
  manufactureDate: {
    value: "22 Aug 2023",
    confidence: "94.74285125732422",
  },
  quantityReadyForShipment: {
    value: "3760",
    confidence: "95.15666198730469",
  },
  consumedBatchQuantity: {
    value: "156048",
    confidence: "94.83992004394531",
  },
  document_type: "ConfirmationOfPartialManufacturingOfAnMedicinalProduct",
  folder_name: "PCI",
  site_name: "Dublin",
  filename:
    "PCI-Dublin-ConfirmationOfPartialManufacturingOfAnMedicinalProduct-45152629-C24050.pdf",
  s3_location:
    "s3://bms-processed-files/PCI/Dublin/45152629-C24050/PCI-Dublin-ConfirmationOfPartialManufacturingOfAnMedicinalProduct-45152629-C24050.pdf",
};

const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
}));

function PartialManufacture() {
  const [isEditable, setIsEditable] = useState(false);
  const [formValues, setFormValues] = useState(initialValuesFromDb);
  const [originalValues] = useState(initialValuesFromDb);
  const [isShowingOriginal, setIsShowingOriginal] = useState(false);
  const [lastSavedValues, setLastSavedValues] = useState(initialValuesFromDb);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    before: "",
    after: "",
    updatedBy: "user123",
    timestamp: new Date().toLocaleString(),
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const classes = useStyles();

  const fields = [
    { key: "producedBatchNumber", label: "Produced Batch Number" },
    { key: "consumedBatchNumber", label: "Consumed Batch Number" },
    { key: "producedBatchCodeBms", label: "Produced Sponsor Batch Code" },
    { key: "producedBatchCodePci", label: "Produced PCI Batch Code" },
    { key: "expiryDate", label: "Expiry Date" },
    { key: "manufactureDate", label: "Manufacture Date" },
    { key: "quantityReadyForShipment", label: "Quantity Ready for Shipment" },
    { key: "consumedBatchQuantity", label: "Consumed Batch Quantity" },
  ];

  const getLevelColor = (level) => {
    const num = typeof level === "string" ? parseFloat(level) : level;
    if (num < 80) return "red";
    if (num <= 90) return "orange";
    return "green";
  };

  const handleInputChange = (key, value) => {
    let isValid = true;

    // Inline filtering logic
    switch (key) {
      case "producedBatchNumber":
      case "consumedBatchNumber":
        isValid = /^[a-zA-Z0-9]*$/.test(value);
        break;
      case "producedBatchCodeBms":
      case "producedBatchCodePci":
      case "quantityReadyForShipment":
      case "consumedBatchQuantity":
        isValid = /^[0-9]*$/.test(value);
        break;
      case "expiryDate":
        isValid =
          /^(\d{0,2}\.?(\d{0,4})?)?$/.test(value) ||
          /^(0[1-9]|1[0-2])\.(19|20)\d{2}$/.test(value);
        break;

      case "manufactureDate":
        isValid = value === "" || value.length <= 50;
        break;

      default:
        isValid = true;
    }

    if (!isValid) return;
    setFormValues((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        value: value,
      },
    }));
  };
  const isFieldChanged = (key) => {
    return formValues[key]?.value !== originalValues[key]?.value;
  };

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">
              Digitized Confirmation of the Partial Manufacturing of an
              Medicinal Product
            </Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        <Grid item container alignItems="center">
          <Grid item style={{ maxWidth: 365 }}>
            <Typography
              variant="h6"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              Confirmation of the Partial Manufacturing of a Medicinal Product
              Data
            </Typography>
          </Grid>
          <Grid item style={{ width: "5px" }} />
          <Grid item>
            <Box display="flex" gap={2} style={{ minWidth: "295px" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (isEditable) {
                    // 🟢 Clone to avoid object reference issue
                    const cloned = JSON.parse(JSON.stringify(formValues));
                    setLastSavedValues(cloned);
                  }
                  setIsEditable((prev) => !prev);
                }}
                style={{ minWidth: 15, textAlign: "center" }}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
              <Grid item style={{ width: "10px" }} />
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  if (!isShowingOriginal) {
                    setFormValues(originalValues);
                  } else {
                    setFormValues(lastSavedValues);
                  }
                  setIsShowingOriginal(!isShowingOriginal);
                  setIsEditable(false);
                }}
                style={{ minWidth: 20, textAlign: "center", size: "20px" }}
              >
                {isShowingOriginal
                  ? "Show Edited Version"
                  : "Show Unedited Version"}
              </Button>
            </Box>
          </Grid>
          <Grid item style={{ width: "0px" }} />
          <Grid item>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {fields.map((field) => (
                <Grid
                  container
                  key={field.key}
                  alignItems="center"
                  spacing={2}
                  className={classes.formField}
                >
                  <Grid item xs={4}>
                    <Typography style={{ paddingRight: 16, fontWeight: 500 }}>
                      {field.label}
                      {![
                        "Produced Sponsor Batch Code",
                        "Produced PCI Batch Code",
                      ].includes(field.label) && (
                        <span className={classes.requiredStar}>*</span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={formValues[field.key]?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.key, e.target.value)
                      }
                      onBlur={(e) => {
                        const { value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (
                          typeof value === "string" &&
                          value.trim() !== value
                        ) {
                          const trimmedValue = value.trim();
                          handleInputChange(field.key, trimmedValue);
                        }
                      }}
                      placeholder={`Enter ${field.label}`}
                      InputProps={{
                        readOnly: !isEditable,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box display="flex" alignItems="center" pl={1}>
                              <Box
                                style={{
                                  width: 1,
                                  height: 39,
                                  backgroundColor: "#ccc",
                                  marginRight: 3,
                                }}
                              />
                              {!isEditable ? (
                                isFieldChanged(field.key) ? (
                                  <Box
                                    onClick={() => {
                                      setModalData({
                                        field: field.label,
                                        before:
                                          originalValues[field.key]?.value,
                                        after:
                                          lastSavedValues[field.key]?.value,
                                        updatedBy: "user123",
                                        timestamp: new Date().toLocaleString(),
                                      });
                                      setOpenModal(true);
                                    }}
                                    style={{
                                      backgroundColor: "#7777",
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Info fontSize="small" />
                                  </Box>
                                ) : (
                                  <Box
                                    style={{
                                      backgroundColor: getLevelColor(
                                        formValues[field.key]?.confidence
                                      ),
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                    }}
                                  >
                                    {Math.round(
                                      formValues[field.key]?.confidence
                                    )}
                                  </Box>
                                )
                              ) : (
                                <Box
                                  style={{
                                    backgroundColor: getLevelColor(
                                      formValues[field.key]?.confidence
                                    ),
                                    color: "white",
                                    borderRadius: 4,
                                    padding: "2px 8px",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    minWidth: 24,
                                    textAlign: "center",
                                  }}
                                >
                                  {Math.round(
                                    formValues[field.key]?.confidence
                                  )}
                                </Box>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              ))}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                <iframe
                  src=""
                  title="PDF Preview"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default PartialManufacture;
